import { OptionType } from '@evinced-private/ui-common';

import { extractLabelKey } from '../../helpers/helpers';
import { TestRowSharedType } from '../../helpers/types';

export const extractExistingLabels = (testRows: TestRowSharedType[]): OptionType[] => {
	if (!testRows?.length) {
		return [];
	}

	const uniqueLabels = new Set<string>();
	testRows.forEach((row: TestRowSharedType) => {
		const labels = row?.labels ?? [];
		labels.forEach((label: string) => {
			if (extractLabelKey(label)) {
				uniqueLabels.add(label);
			}
		});
	});

	return [...uniqueLabels]
		.map((label) => ({ value: label, label: label as string }))
		.sort((a, b) => a.label.localeCompare(b.label));
};
